<div class="card mb-5 gy-5 g-xl-8">
  <div class="card-body position-relative pb-0">

    <app-dashboard-card-summary
      [series]="statsData"
      [smallChartStats]="smallChartStats"
      [statsTotalData]="statsTotalData"
      [selectedCharts]="(dashboardCardService.selectedCharts$ | async) || []"
      [selectedMetrics]="(dashboardCardService.selectedMetrics$ | async) || []"
      [excludedMetrics]="excludedMetrics"
      [selectedChartsPalletes]="dashboardCardService.selectedChartsColors$ | async"
      (selectChart)="dashboardCardService.toggleSelectedChart($event)"
      (selectMetrics)="dashboardCardService.setSelectedMetrics($event)"
    ></app-dashboard-card-summary>

    <div class="separator border-gray-200 my-5"></div>

    <app-dashboard-chart
      *ngIf="statsData"
      [bigChartStats]="(statsData | appDashboardCardStats:smallChartStats | async) || []"
      [isFakeData]="isEmptyData"
      [selectedChartsPalletes]="dashboardCardService.selectedChartsColors$ | async"
    ></app-dashboard-chart>

    <app-overlay-loader *ngIf="isLoading"></app-overlay-loader>
  </div>
</div>
